export const obligationsPtBr = {
  section: {
    title: 'Pendências',
    titleWithCount: '{{title}} ({{count}})',
    loadingLabel: 'Carregando pendências…',
    emptyTitle: 'Nada para decidir',
    emptyDescription: 'Você não tem nenhuma pendência no momento.',
    clearFilter: 'Limpar filtro',
    clearFilters: 'Limpar filtros',
    retry: 'Tentar novamente',
  },
  sectionReview: {
    title: 'Avisos',
    loadingLabel: 'Carregando avisos…',
    emptyTitle: 'Nenhum aviso',
    emptyDescription: 'Você não tem nenhum aviso no momento.',
  },
  table: {
    module: 'Módulo',
    dueDate: 'Vencimento',
    details: 'Detalhes',
    who: 'Quem',
    // Renamed from "Classificação" — this column also carries generic,
    // person-less notification content (Open Finance connection issues,
    // etc.), not just accounting classification, so a broader label fits
    // both (obligations table review follow-up).
    classification: 'Detalhes',
    amount: 'Valor',
    roleVendor: 'Fornecedor',
    roleRequester: 'Solicitante',
    roleCollaborator: 'Colaborador',
    // Line 1 of the Classificação column — each adapter picks whichever of
    // these actually describes its own data instead of one generic
    // "Referência" that told the reader nothing about what the value was
    // (ALC-3244 review follow-up).
    reference: {
      docNumber: 'Nº Doc',
      number: 'Nº',
      description: 'Descrição',
      title: 'Título',
      merchant: 'Estabelecimento',
      justification: 'Justificativa',
      document: 'Documento',
    },
    // Line 2 — classification chips. Full names, not abbreviations — an
    // earlier version of this column shortened these (CC, Dep., C. Ger.) to
    // leave more room for the values, but that read as unclear (ALC-3244
    // review follow-up: reverts to spelling every dimension out).
    classificationShort: {
      glAccount: 'Conta contábil',
      costCenter: 'Centro de custo',
      department: 'Departamento',
      managerialAccount: 'Conta gerencial',
      segment: 'Segmento',
    },
    sortAscending: 'crescente',
    sortDescending: 'decrescente',
    sortByAria: 'Ordenar por {{field}}{{direction}}',
    sortTooltip: 'Clique para ordenar',
    filterColumnTooltip: 'Filtrar',
    filterDueDateAria: 'Filtrar por vencimento',
    dueDateRangeBoth: '{{from}} - {{to}}',
    dueDateRangeFrom: 'A partir de {{date}}',
    dueDateRangeTo: 'Até {{date}}',
    filterModuleAria: 'Filtrar por módulo',
  },
  dueRelative: {
    today: 'vence hoje',
    inDays_one: 'em {{count}} dia',
    inDays_other: 'em {{count}} dias',
    overdue: 'atrasado {{count}}d',
  },
  buckets: {
    overdue: 'Atrasadas',
    dueToday: 'Vencem hoje',
    dueThisWeek: 'Esta semana',
    later: 'Mais adiante',
    itemCount_one: '{{count}} item',
    itemCount_other: '{{count}} itens',
  },
  bulkBar: {
    selectedCount_one: '{{count}} selecionado',
    selectedCount_other: '{{count}} selecionados',
    totalLabel: 'Total:',
    selectAllAria: 'Selecionar todas as linhas',
    approve: 'Aprovar selecionados',
    reject: 'Rejeitar selecionados',
    clear: 'Limpar seleção',
    disabledMixedTypes:
      'Selecione itens de um único módulo para agir em lote. Itens de módulos diferentes precisam ser aprovados ou rejeitados separadamente.',
    disabledNoPermission: 'Você não tem permissão para esta ação neste módulo.',
    rejectDialog: {
      title: 'Rejeitar em lote',
      description:
        'Esta rejeição será aplicada a todos os itens selecionados e registrada permanentemente. Essa ação não pode ser desfeita.',
      reasonLabel: 'Motivo da rejeição (obrigatório)',
      placeholder: 'Motivo da rejeição, aplicado a todos os itens selecionados...',
      cancel: 'Cancelar',
      confirm: 'Confirmar rejeição',
    },
    toast: {
      allSucceeded: 'Ação aplicada a todos os itens selecionados',
      partialFailure_one: '{{failed}} de {{total}} item falhou',
      partialFailure_other: '{{failed}} de {{total}} itens falharam',
      allFailed: 'Não foi possível aplicar a ação aos itens selecionados',
    },
  },
  genericRow: {
    fallbackLabel: 'Pendência: {{type}}',
    types: {
      // AP_PURCHASE_REQUEST_APPROVAL_STEP has a dedicated adapter
      // (obligation-adapter-registry.ts) and never falls through to this
      // generic row — only AP_BILL_WORKFLOW_NOTIFICATION (a link-out row
      // with no adapter of its own) actually reaches this label.
      AP_BILL_WORKFLOW_NOTIFICATION: 'Notificação de conta a pagar',
      AP_BILL_AI_POSTING_STUCK: 'Provisão contábil não postada',
      BUDGET_LINE_ALERT: 'Linha de orçamento em revisão',
      BUDGET_LINE_PROJECTED_EXCEEDED: 'Projeção de orçamento ultrapassada',
      BUDGET_LINE_THRESHOLD: 'Limite de utilização de orçamento atingido',
      BUDGET_EXCEPTION_APPROVED: 'Exceção de orçamento aprovada',
      BUDGET_EXCEPTION_REJECTED: 'Exceção de orçamento rejeitada',
      OPEN_FINANCE_CONNECTION_ERROR: 'Erro de conexão Open Finance',
      OPEN_FINANCE_OWNER_DOCUMENT_MISMATCH: 'Titular da conexão Open Finance não confere',
      FISCAL_OBLIGATION_DEADLINE: 'Obrigação fiscal perto do vencimento',
      FISCAL_OBLIGATION_UNASSIGNED: 'Obrigação fiscal sem responsável',
      FISCAL_CHANNEL_EXPIRY: 'Certificado ou procuração perto do vencimento',
      FISCAL_COMMUNICATION_DEADLINE: 'Comunicação oficial perto do prazo de ciência',
    },
    viewLink: 'Ver',
    reconnectLink: 'Reconectar',
    reviewLink: 'Revisar',
  },
  review: {
    fallbackLabel: 'Aviso: {{type}}',
    dismiss: 'Dispensar',
    dismissedToast: 'Aviso dispensado',
    dismissErrorToast: 'Erro ao dispensar o aviso',
    markRead: 'Marcar como lida',
    markedReadToast: 'Aviso marcado como lido',
    markReadErrorToast: 'Erro ao marcar o aviso como lido',
    confirmDialog: {
      title: 'Dispensar aviso',
      description:
        'Este aviso será removido da sua lista e não vai voltar. Essa ação não pode ser desfeita.',
      cancel: 'Cancelar',
      confirm: 'Sim, dispensar',
    },
    // Interpolated one-line sentences (ALC-3172) — each key's params are
    // built by resolveReviewRowDetail (lib/obligations/review-row-detail),
    // already formatted (currency, percent) except `tier`, which this
    // component resolves separately via `tier.*` below. A row missing the
    // fields its type needs falls back to `genericRow.types.*` instead of
    // reaching these keys at all.
    // `<amt>` marks a currency amount for `<Trans>` to render through a
    // `font-mono tabular-nums` span (UI-02) — plain `{{param}}`
    // interpolation would render it as unstyled prose instead.
    details: {
      BUDGET_LINE_ALERT:
        '{{lineLabel}} — <amt>{{excessAmount}}</amt> acima do orçado (<amt>{{budgetAmount}}</amt>)',
      BUDGET_LINE_PROJECTED_EXCEEDED:
        '{{lineLabel}} — projeção de <amt>{{projectedTotal}}</amt> contra orçado <amt>{{budgetAmount}}</amt>',
      BUDGET_LINE_THRESHOLD: '{{lineLabel}} — {{utilizationPct}} utilizado ({{tier}})',
      BUDGET_EXCEPTION_APPROVED: '{{lineLabel}} — exceção de <amt>{{excessAmount}}</amt> aprovada',
      BUDGET_EXCEPTION_REJECTED: '{{lineLabel}} — exceção de <amt>{{excessAmount}}</amt> rejeitada',
    },
    tier: {
      WARNING: 'atenção',
      CRITICAL: 'crítico',
    },
  },
  reimbursement: {
    groupLabel: 'Reembolsos',
    columns: {
      dueDate: 'Vencimento',
      requester: 'Solicitante',
      amount: 'Valor',
    },
    noRequester: 'Solicitante não informado',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    review: 'Revisar',
    rejectDialog: {
      title: 'Rejeitar reembolso',
      description:
        'Esta rejeição será registrada permanentemente e o reembolso voltará para revisão do solicitante. Essa ação não pode ser desfeita.',
      reasonLabel: 'Motivo da rejeição (obrigatório)',
      placeholder: 'Motivo da rejeição...',
      cancel: 'Cancelar',
      confirm: 'Confirmar rejeição',
    },
    toast: {
      approved: 'Reembolso aprovado com sucesso',
      rejected: 'Reembolso rejeitado',
      approveError: 'Erro ao aprovar reembolso',
      rejectError: 'Erro ao rejeitar reembolso',
    },
  },
  billApproval: {
    groupLabel: 'Contas a pagar',
  },
  purchaseRequest: {
    groupLabel: 'Compras',
    noRequester: 'Solicitante não informado',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    review: 'Revisar',
    rejectDialog: {
      title: 'Rejeitar requisição de compra',
      description:
        'Esta rejeição será registrada permanentemente e a requisição voltará para revisão do solicitante. Essa ação não pode ser desfeita.',
      reasonLabel: 'Motivo da rejeição (obrigatório)',
      placeholder: 'Motivo da rejeição...',
      cancel: 'Cancelar',
      confirm: 'Confirmar rejeição',
    },
    toast: {
      approved: 'Requisição de compra aprovada com sucesso',
      rejected: 'Requisição de compra rejeitada',
      approveError: 'Erro ao aprovar requisição de compra',
      rejectError: 'Erro ao rejeitar requisição de compra',
    },
  },
  budget: {
    groupLabel: 'Orçamento',
  },
  openFinance: {
    groupLabel: 'Integrações',
  },
  fiscal: {
    groupLabel: 'Fiscal',
  },
  budgetException: {
    groupLabel: 'Orçamento',
    noRequester: 'Solicitante não informado',
    budgetLineChip: 'Linha: {{name}}',
    excessAmountLabel: 'Excedente',
    requestType: {
      EXCEPTION: 'Exceção',
      LIMIT_INCREASE: 'Aumento de limite',
    },
    approve: 'Aprovar',
    reject: 'Rejeitar',
    review: 'Revisar',
    rejectDialog: {
      title: 'Rejeitar exceção de orçamento',
      description:
        'Esta rejeição será registrada permanentemente. Essa ação não pode ser desfeita.',
      reasonLabel: 'Motivo da rejeição (obrigatório)',
      placeholder: 'Motivo da rejeição...',
      cancel: 'Cancelar',
      confirm: 'Confirmar rejeição',
    },
    toast: {
      approved: 'Exceção de orçamento aprovada com sucesso',
      rejected: 'Exceção de orçamento rejeitada',
      approveError: 'Erro ao aprovar exceção de orçamento',
      rejectError: 'Erro ao rejeitar exceção de orçamento',
    },
  },
  fleetProposal: {
    groupLabel: 'Agente',
    roleAgent: 'Agente',
    agents: {
      reconciliation: 'Agente de conciliação',
      generic: 'Agente',
    },
    kinds: {
      duplicate_fast_track: {
        title: '{{vendor}}: conta duplicada do fast-track',
        summary:
          'A conta {{voidLabel}} chegou por e-mail e já foi paga como fast-track ({{keepLabel}}). Invalidar a conta do e-mail e anexar {{documents}} documento(s) à conta do fast-track?',
      },
      twin_bills: {
        title: '{{vendor}}: conta importada duas vezes',
        summary:
          'As contas {{keepLabel}} e {{voidLabel}} têm o mesmo número de nota. Manter a primeira, invalidar a segunda e anexar {{documents}} documento(s) à primeira?',
      },
      moved_link: {
        title: '{{vendor}}: vínculo na conta errada',
        summary:
          'A cobrança de {{amount}} está conciliada com a conta {{fromLabel}}, mas outra conta do fornecedor ({{toLabel}}) tem exatamente esse valor. Mover o vínculo para ela?',
      },
    },
    accept: 'Aceitar',
    acceptNeedsVoidPermission:
      'Anular a conta exige as permissões de excluir e de editar contas a pagar.',
    decideNeedsRulePermission:
      'Decidir uma regra de conciliação exige as permissões de gerenciar o conhecimento de fornecedores e de ver parceiros.',
    reject: 'Rejeitar',
    viewRun: 'Ver execução',
    rejectDialog: {
      title: 'Rejeitar esta proposta?',
      description:
        '"{{title}}" não será proposta de novo para este par. A decisão fica registrada.',
      confirm: 'Rejeitar proposta',
      cancel: 'Cancelar',
    },
    toast: {
      accepted: 'Proposta aceita',
      acceptError: 'Não foi possível aceitar a proposta',
      refused: 'A proposta não vale mais com os dados atuais.',
      rejected: 'Proposta rejeitada. O par não será proposto de novo.',
      rejectError: 'Não foi possível rejeitar a proposta',
    },
  },
  ruleReview: {
    groupLabel: 'Regra de conciliação',
    summary: 'Cobrança = recibo × (1 + {{rate}}%), diferença lançada como {{bookAs}}',
    rate: '{{rate}}%',
    source: {
      card: 'Cartão',
      bank: 'Banco',
    },
    approve: 'Aprovar',
    reject: 'Rejeitar',
    later: 'Decidir depois',
    rejectDialog: {
      title: 'Rejeitar a regra de {{vendor}}?',
      description:
        'A regra deixa de valer. Em seguida você vê as conciliações que ela já fez, para desfazer de uma vez.',
      confirm: 'Rejeitar regra',
      cancel: 'Cancelar',
    },
    toast: {
      approved: 'Regra aprovada',
      approveError: 'Não foi possível aprovar a regra',
      rejected: 'Regra rejeitada',
      rejectError: 'Não foi possível rejeitar a regra',
      later: 'Tarefa movida para o fim da fila',
      laterError: 'Não foi possível adiar a tarefa',
    },
    matches: {
      title: 'Conciliações feitas com a regra de {{vendor}}',
      description_one: 'A regra liquidou {{count}} conciliação. Desfaça todas de uma vez.',
      description_other: 'A regra liquidou {{count}} conciliações. Desfaça todas de uma vez.',
      afterUndo: 'Desfeitas: {{count}}. Continuam na lista: {{remaining}}, para uma pessoa tratar.',
      undoAll: 'Desfazer {{count}}',
      close: 'Fechar',
      loadError: 'Não foi possível carregar as conciliações da regra.',
      emptyTitle: 'Nenhuma conciliação para desfazer',
      emptyDescription: 'A regra não liquidou nada, ou tudo já foi desfeito.',
      columns: {
        match: 'Conciliação',
        decidedAt: 'Feita em',
        amount: 'Valor',
      },
      blocked: {
        PERIOD_CLOSED: 'Período fechado: precisa de uma pessoa',
        BLOCKED: 'Não pôde ser desfeita: precisa de uma pessoa',
      },
    },
  },
} as const;

export const obligationsEn = {
  section: {
    title: 'Pending',
    titleWithCount: '{{title}} ({{count}})',
    loadingLabel: 'Loading pending items…',
    emptyTitle: 'Nothing to decide',
    emptyDescription: "You don't have any pending items right now.",
    clearFilter: 'Clear filter',
    clearFilters: 'Clear filters',
    retry: 'Try again',
  },
  sectionReview: {
    title: 'Notices',
    loadingLabel: 'Loading notices…',
    emptyTitle: 'No notices',
    emptyDescription: "You don't have any notices right now.",
  },
  table: {
    module: 'Module',
    dueDate: 'Due date',
    details: 'Details',
    who: 'Who',
    classification: 'Details',
    amount: 'Amount',
    roleVendor: 'Vendor',
    roleRequester: 'Requester',
    roleCollaborator: 'Collaborator',
    reference: {
      docNumber: 'Doc #',
      number: 'No.',
      description: 'Description',
      title: 'Title',
      merchant: 'Merchant',
      justification: 'Justification',
      document: 'Document',
    },
    classificationShort: {
      glAccount: 'GL account',
      costCenter: 'Cost center',
      department: 'Department',
      managerialAccount: 'Managerial account',
      segment: 'Segment',
    },
    sortAscending: 'ascending',
    sortDescending: 'descending',
    sortByAria: 'Sort by {{field}}{{direction}}',
    sortTooltip: 'Click to sort',
    filterColumnTooltip: 'Filter',
    filterDueDateAria: 'Filter by due date',
    dueDateRangeBoth: '{{from}} - {{to}}',
    dueDateRangeFrom: 'From {{date}}',
    dueDateRangeTo: 'Until {{date}}',
    filterModuleAria: 'Filter by module',
  },
  dueRelative: {
    today: 'due today',
    inDays_one: 'in {{count}} day',
    inDays_other: 'in {{count}} days',
    overdue: '{{count}}d overdue',
  },
  buckets: {
    overdue: 'Overdue',
    dueToday: 'Due today',
    dueThisWeek: 'This week',
    later: 'Later',
    itemCount_one: '{{count}} item',
    itemCount_other: '{{count}} items',
  },
  bulkBar: {
    selectedCount_one: '{{count}} selected',
    selectedCount_other: '{{count}} selected',
    totalLabel: 'Total:',
    selectAllAria: 'Select all rows',
    approve: 'Approve selected',
    reject: 'Reject selected',
    clear: 'Clear selection',
    disabledMixedTypes:
      'Select items from a single module to act on them in bulk. Items from different modules need to be approved or rejected separately.',
    disabledNoPermission: "You don't have permission for this action in this module.",
    rejectDialog: {
      title: 'Bulk reject',
      description:
        'This rejection will be applied to every selected item and permanently recorded. This action cannot be undone.',
      reasonLabel: 'Rejection reason (required)',
      placeholder: 'Rejection reason, applied to every selected item...',
      cancel: 'Cancel',
      confirm: 'Confirm rejection',
    },
    toast: {
      allSucceeded: 'Action applied to every selected item',
      partialFailure_one: '{{failed}} of {{total}} item failed',
      partialFailure_other: '{{failed}} of {{total}} items failed',
      allFailed: 'Could not apply the action to the selected items',
    },
  },
  genericRow: {
    fallbackLabel: 'Pending: {{type}}',
    types: {
      // AP_PURCHASE_REQUEST_APPROVAL_STEP has a dedicated adapter
      // (obligation-adapter-registry.ts) and never falls through to this
      // generic row — only AP_BILL_WORKFLOW_NOTIFICATION (a link-out row
      // with no adapter of its own) actually reaches this label.
      AP_BILL_WORKFLOW_NOTIFICATION: 'Bill notification',
      AP_BILL_AI_POSTING_STUCK: 'Accounting provision not posted',
      BUDGET_LINE_ALERT: 'Budget line under review',
      BUDGET_LINE_PROJECTED_EXCEEDED: 'Projected budget overage',
      BUDGET_LINE_THRESHOLD: 'Budget utilization threshold reached',
      BUDGET_EXCEPTION_APPROVED: 'Budget exception approved',
      BUDGET_EXCEPTION_REJECTED: 'Budget exception rejected',
      OPEN_FINANCE_CONNECTION_ERROR: 'Open Finance connection error',
      OPEN_FINANCE_OWNER_DOCUMENT_MISMATCH: 'Open Finance connection owner mismatch',
      FISCAL_OBLIGATION_DEADLINE: 'Tax obligation near its due date',
      FISCAL_OBLIGATION_UNASSIGNED: 'Tax obligation without a responsible',
      FISCAL_CHANNEL_EXPIRY: 'Certificate or power of attorney near its end',
      FISCAL_COMMUNICATION_DEADLINE: 'Official communication near its deadline for notice',
    },
    viewLink: 'View',
    reconnectLink: 'Reconnect',
    reviewLink: 'Review',
  },
  review: {
    fallbackLabel: 'Notice: {{type}}',
    dismiss: 'Dismiss',
    dismissedToast: 'Notice dismissed',
    dismissErrorToast: 'Error dismissing the notice',
    markRead: 'Mark as read',
    markedReadToast: 'Notice marked as read',
    markReadErrorToast: 'Error marking the notice as read',
    confirmDialog: {
      title: 'Dismiss notice',
      description:
        'This notice will be removed from your list and will not come back. This action cannot be undone.',
      cancel: 'Cancel',
      confirm: 'Yes, dismiss',
    },
    details: {
      BUDGET_LINE_ALERT:
        '{{lineLabel}} — <amt>{{excessAmount}}</amt> over budget (<amt>{{budgetAmount}}</amt>)',
      BUDGET_LINE_PROJECTED_EXCEEDED:
        '{{lineLabel}} — projected <amt>{{projectedTotal}}</amt> against budgeted <amt>{{budgetAmount}}</amt>',
      BUDGET_LINE_THRESHOLD: '{{lineLabel}} — {{utilizationPct}} utilized ({{tier}})',
      BUDGET_EXCEPTION_APPROVED: '{{lineLabel}} — <amt>{{excessAmount}}</amt> exception approved',
      BUDGET_EXCEPTION_REJECTED: '{{lineLabel}} — <amt>{{excessAmount}}</amt> exception rejected',
    },
    tier: {
      WARNING: 'warning',
      CRITICAL: 'critical',
    },
  },
  reimbursement: {
    groupLabel: 'Reimbursements',
    columns: {
      dueDate: 'Due date',
      requester: 'Requester',
      amount: 'Amount',
    },
    noRequester: 'Requester not informed',
    approve: 'Approve',
    reject: 'Reject',
    review: 'Review',
    rejectDialog: {
      title: 'Reject reimbursement',
      description:
        'This rejection will be permanently recorded and the reimbursement returns to the requester for review. This action cannot be undone.',
      reasonLabel: 'Rejection reason (required)',
      placeholder: 'Rejection reason...',
      cancel: 'Cancel',
      confirm: 'Confirm rejection',
    },
    toast: {
      approved: 'Reimbursement approved successfully',
      rejected: 'Reimbursement rejected',
      approveError: 'Error approving reimbursement',
      rejectError: 'Error rejecting reimbursement',
    },
  },
  billApproval: {
    groupLabel: 'Bills',
  },
  purchaseRequest: {
    groupLabel: 'Purchasing',
    noRequester: 'Requester not informed',
    approve: 'Approve',
    reject: 'Reject',
    review: 'Review',
    rejectDialog: {
      title: 'Reject purchase request',
      description:
        'This rejection will be permanently recorded and the request returns to the requester for review. This action cannot be undone.',
      reasonLabel: 'Rejection reason (required)',
      placeholder: 'Rejection reason...',
      cancel: 'Cancel',
      confirm: 'Confirm rejection',
    },
    toast: {
      approved: 'Purchase request approved successfully',
      rejected: 'Purchase request rejected',
      approveError: 'Error approving purchase request',
      rejectError: 'Error rejecting purchase request',
    },
  },
  budget: {
    groupLabel: 'Budget',
  },
  openFinance: {
    groupLabel: 'Integrations',
  },
  fiscal: {
    groupLabel: 'Tax',
  },
  budgetException: {
    groupLabel: 'Budget',
    noRequester: 'Requester not informed',
    budgetLineChip: 'Line: {{name}}',
    excessAmountLabel: 'Excess',
    requestType: {
      EXCEPTION: 'Exception',
      LIMIT_INCREASE: 'Limit increase',
    },
    approve: 'Approve',
    reject: 'Reject',
    review: 'Review',
    rejectDialog: {
      title: 'Reject budget exception',
      description: 'This rejection will be permanently recorded. This action cannot be undone.',
      reasonLabel: 'Rejection reason (required)',
      placeholder: 'Rejection reason...',
      cancel: 'Cancel',
      confirm: 'Confirm rejection',
    },
    toast: {
      approved: 'Budget exception approved successfully',
      rejected: 'Budget exception rejected',
      approveError: 'Error approving budget exception',
      rejectError: 'Error rejecting budget exception',
    },
  },
  fleetProposal: {
    groupLabel: 'Agent',
    roleAgent: 'Agent',
    agents: {
      reconciliation: 'Reconciliation agent',
      generic: 'Agent',
    },
    kinds: {
      duplicate_fast_track: {
        title: '{{vendor}}: duplicate of a fast-track bill',
        summary:
          'Bill {{voidLabel}} came in by email and was already paid as a fast-track bill ({{keepLabel}}). Void the email bill and attach its {{documents}} document(s) to the fast-track bill?',
      },
      twin_bills: {
        title: '{{vendor}}: bill imported twice',
        summary:
          'Bills {{keepLabel}} and {{voidLabel}} have the same invoice number. Keep the first, void the second and attach its {{documents}} document(s) to the first?',
      },
      moved_link: {
        title: '{{vendor}}: link on the wrong bill',
        summary:
          'The {{amount}} charge is reconciled with bill {{fromLabel}}, but another bill of the vendor ({{toLabel}}) is for exactly that amount. Move the link to it?',
      },
    },
    accept: 'Accept',
    acceptNeedsVoidPermission:
      'Voiding the bill needs both the delete and the edit bill permissions.',
    decideNeedsRulePermission:
      'Deciding a reconciliation rule needs the manage vendor knowledge and view partners permissions.',
    reject: 'Reject',
    viewRun: 'View run',
    rejectDialog: {
      title: 'Reject this proposal?',
      description:
        '"{{title}}" will not be proposed again for this pair. The decision is recorded.',
      confirm: 'Reject proposal',
      cancel: 'Cancel',
    },
    toast: {
      accepted: 'Proposal accepted',
      acceptError: 'Could not accept the proposal',
      refused: 'The proposal no longer holds on current data.',
      rejected: 'Proposal rejected. The pair will not be proposed again.',
      rejectError: 'Could not reject the proposal',
    },
  },
  ruleReview: {
    groupLabel: 'Reconciliation rule',
    summary: 'Charge = receipt × (1 + {{rate}}%), gap booked as {{bookAs}}',
    rate: '{{rate}}%',
    source: {
      card: 'Card',
      bank: 'Bank',
    },
    approve: 'Approve',
    reject: 'Reject',
    later: 'Decide later',
    rejectDialog: {
      title: 'Reject the {{vendor}} rule?',
      description:
        'The rule stops applying. You then see the reconciliations it already made, to undo them at once.',
      confirm: 'Reject rule',
      cancel: 'Cancel',
    },
    toast: {
      approved: 'Rule approved',
      approveError: 'Could not approve the rule',
      rejected: 'Rule rejected',
      rejectError: 'Could not reject the rule',
      later: 'Task moved to the end of the queue',
      laterError: 'Could not postpone the task',
    },
    matches: {
      title: 'Reconciliations made with the {{vendor}} rule',
      description_one: 'The rule settled {{count}} reconciliation. Undo them all at once.',
      description_other: 'The rule settled {{count}} reconciliations. Undo them all at once.',
      afterUndo: 'Undone: {{count}}. Still listed: {{remaining}}, for a person to handle.',
      undoAll: 'Undo {{count}}',
      close: 'Close',
      loadError: 'Could not load the reconciliations of this rule.',
      emptyTitle: 'No reconciliations to undo',
      emptyDescription: 'The rule settled nothing, or everything is already undone.',
      columns: {
        match: 'Reconciliation',
        decidedAt: 'Made on',
        amount: 'Amount',
      },
      blocked: {
        PERIOD_CLOSED: 'Closed period: needs a person',
        BLOCKED: 'Could not be undone: needs a person',
      },
    },
  },
} as const;
